/*
 * @Description: 提示信息
 * @Author: 裴孚
 * @Date: 2022-11-15 15:25:27
 * @LastEditors: 裴孚
 * @LastEditTime: 2023-07-11 08:56:37
 */

import { ElNotification, ElMessage, ElMessageBox } from 'element-plus'
// 成功提示
export function successPrompt (data) {
  if (document.getElementsByClassName('el-message-box').length === 0) {
    ElNotification({
      title: '提示',
      message: data,
      type: 'success',
      position: 'bottom-right',
      duration: 3000
    })
  }
}
// 消息提示
export function messagePrompt (data) {
  if (document.getElementsByClassName('el-message-box').length === 0) {
    ElMessage(data)
  }
}
// 警告提示
export function warningPrompt (data) {
  if (document.getElementsByClassName('el-message-box').length === 0) {
    ElMessageBox.confirm(data, '警告',
      {
        showCancelButton: false,
        confirmButtonText: '关闭',
        type: 'warning'
      }
    )
  }
}
// 错误提示
export function errorPrompt (data) {
  if (document.getElementsByClassName('el-message-box').length === 0) {
    ElMessageBox.confirm(data, '错误',
      {
        showCancelButton: false,
        confirmButtonText: '关闭',
        type: 'error'
      }
    )
  }
}
